import React, { PropsWithChildren } from "react";
import { NavLink as RRNavLink } from "react-router";

interface Props {
  to: string;
  end?: boolean;
  closeMenu?: () => void;
}

{
  /* https://api.reactrouter.com/v7/functions/react_router.NavLink.html */
}
const NavLink: React.FC<PropsWithChildren<Props>> = (
  props,
): React.ReactElement => {
  return (
    <RRNavLink
      className={({ isActive }) =>
        `block px-5 py-2 ${isActive ? "bg-bgcolor text-primary rounded-lg font-semibold" : "font-medium"} hover:text-primary`
      }
      to={props.to}
      end={props.end}
      onClick={() => props.closeMenu?.()}
    >
      <div className="inline-block text-center">{props.children}</div>
    </RRNavLink>
  );
};

export default NavLink;
